/**
 * Group preview
 */

var AwesomeGroup = function (){
    'use strict';
    var $ = jQuery,
        self = this,
        tooltip_hint = '<p class="hint">Notice: style settings for Skype, Phone, Email and Website are common for all these fields.</p>',
        form = new AwesomeForm();

    self.preview = $('.group-preview', aet_panel);
    self.testimonials_panel = '#panel-testimonials';
    self.layout = model.get('layout');
    self.colorpickers = [
        'button',
        'button_hover',
        'button_text',
        'button_text_hover',
        'base',
        'panel',
        'card_base',
        'card_border',
        'divider',
        'card_shadow',
        'card_even_row',
        'name',
        'position',
        'short_text',
        'contacts',
        'social',
        'source',
        'rating_bar',
        'rating_text',
        'short_text_border',
        'short_text_background',
    ];
    self.tooltips = {
        photo: {
            type: 'photo',
            hint: ''
        },
        name: {
            type: 'font',
            hint: ''
        },
        position: {
            type: 'font',
            hint: ''
        },
        short_text: {
            type: 'short_text',
            hint: ''
        },
        divider: {
            type: 'divider',
            hint: ''
        },
        source: {
            type: 'font',
            hint: ''
        },
        rating: {
            type: 'rating',
            hint: ''
        },
        social: {
            type: 'social',
            hint: ''
        }
    };

    self.labels = {
        grid: {
            name: 'Card',
            card_divider_color: 'Divider'
        },
        grid_float: {
            name: 'Card',
            card_divider_color: 'Divider'
        },
        single: {
            name: 'Card',
            card_divider_color: 'Divider'
        },
        single_showcase: {
            name: 'Card',
            card_divider_color: 'Divider'
        },
        widget: {
            name: 'Card',
            card_divider_color: 'Divider'
        }
    };

    // show personal style fields
    self.show_fields = function(){
        var dfd = $.Deferred();
        var blocks = model.get('styles.' + model.get('layout') + '.blocks_order');
        var layout = model.get('layout');

        if(layout == 'grid' || layout == 'single'){
            $('.group-blocks-visibility .visible').hide();
            $.each(blocks, function (index, item) {
                $('.' + item + '_visible').show();
            });
        }
        blocks = model.get('styles.' + layout);

        $('#group-form .model-field').hide();
        $.each(blocks, function (key, value) {
            $('#group-form .' + key).show(); // show field block
            if(key in self.labels[layout]){
                $('#group-form .' + key + ' .input-group-addon', aet_panel).eq(0).html(self.labels[layout][key]); // rename layout special fields labels if exist
            }
        });

        $('.interface-elements', aet_panel).show();
        $('.interface-styling', aet_panel).show();
        $('h5.card-label', aet_panel).html(self.labels[layout].name + ' settings');
        $('h5.layout-label', aet_panel).show();

        if(layout == 'single' || layout == 'single_showcase' || layout == 'widget'){
            $('.interface-elements', aet_panel).hide();
        }
        if(layout == 'single' || layout == 'widget'){
            $('h5.layout-label', aet_panel).hide();
        }
        $('.empty-model .hint').html('Add at least one employee from the main plugins\' screen.');

        dfd.resolve();
        return dfd;
    };

    self.insert_preview_html = function () {
        var layout = model.get('layout');
        var html = model.get(layout + '_html');
        self.preview.html(html); // append preview based on current group layout option
    };

    // two way data bindings for edit group form
    self.bind_form = function(){
        var dfd = $.Deferred();

        // layout align
        $('.group-align .btn', aet_panel).on('click', function(e){
            e.preventDefault();
            var $el = $(this);
            var $parent = $el.parent('.btn-group');
            var $input = $el.find('input');
            var value = $input.attr('data-value');
            var model_field = 'styles.' + model.get('layout') + '.align';

            $parent.find('.btn').removeClass('active');
            model.set(model_field, value);
            $el.addClass('active');
        });

        // preview blocks visibility
        $('.toggle', aet_panel).on('click', function(e){
            e.preventDefault();
            var $el = $(this);
            var $input = $el.find('input');
            var group = $el.attr('data-group') || '';
            var field = $input.attr('name').split('group_' + group + '_').join('');
            if(group == 'styles'){
                var model_field = group + '.' + model.get('layout') + '.' + field;
            }else{
                var model_field = group + '.' + field;
            }

            $input.prop('checked', 'checked');
            if($input.attr('data-checked') == 1){
                model.set(model_field, '0');
                $input.val('0');
                $input.attr('data-checked', '0');
            }else{
                model.set(model_field, '1');
                $input.val('1');
                $input.attr('data-checked', '1');
            }
        });

        // panels accordion
        $('.panel-collapse-group .panel-heading').on('click', function () {
            var opened = $(this).hasClass('a-collapse-head-open');
            if(opened){
                return false;
            }
            var group = $(this).parents('.panel-collapse-group').eq(0);
            $('.panel-body', group).addClass('a-collapse');
            $('.panel-heading', group).removeClass('a-collapse-head-open');
            $(this).next('.panel-body').removeClass('a-collapse');
            $(this).toggleClass('a-collapse-head-open');
        });

        // icon manager
        $(document).on('click', '[data-action="icon-manager"]', function (e) {
            e.preventDefault();
            var target = '#' + $(this).attr('data-target');
            $(target, aet_panel).toggle();
            $(this).toggleClass('active');
        });

        // select icon
        $(document).on('click', '[data-action="change-rating-icon"]', function(e){
            var layout = model.get('layout');
            var field_model = 'styles.' + layout + '.rating_icon';
            var name = $(this).attr('data-name');
            model.set(field_model, name);
        });

        $(document).on('click', '[data-action="accept-rating-custom-icon"]', function (e) {
            var layout = model.get('layout');
            var base = 'styles.' + layout + '.';
            var source = $('[name="group_rating_source"]').val();
            model.set(base + 'rating_source', source);
            model.set(base + 'rating_icon', 'replace');
        });

        $(document).on('input', '[name="icon_manager_search"]', function(e){
            var icons = $(this).parents('.icon-manager').eq(0).find('.glyph');
            var query = $(this).val();
            $.each(icons, function (index, item) {
                var aliases = $(item).attr('data-aliases') || '';
                $(item).show();
                if(aliases.indexOf(query) == -1){
                    $(item).hide();
                }
            });
        });

        window.group_form_view = new GroupForm({
            model: window.model
        });
        group_form_view.setElement($('#group-form', aet_panel));
        group_form_view.render();
        dfd.resolve();
        return dfd;
    };

    // two way data binding for group preview
    self.bind_preview = function(){
        var dfd = $.Deferred();
        window.preview_view = new GroupPreview({
            model: window.model
        });
        preview.insert_preview_html();
        self.redraw_order();
        preview_view.setElement($('#group-form', aet_panel));
        preview_view.render();
        dfd.resolve();
        return dfd;
    };

    self.bind_sortable = function ($item, axis, helper, onstart, onupdate) {
        $item.sortable({
            axis: axis,
            forcePlaceholderSize: true,
            forceHelperSize: true,
            placeholder: 'preview-placeholder',
            helper: helper,
            start: onstart,
            update: onupdate
        });
    };

    self.insert_blocks_into_builder = function(blocks, item, level){
        var result = '';

        $.each(blocks, function (index, block) {
            if(typeof block === 'object'){
                result += '<div class="sortable-box level-' + ++level + '">';
                result += self.insert_blocks_into_builder(block, item, level);
                result += '</div>';
            }else{
                result += $('<div>').append(item.find('.testimonial_' + block).clone()).html();
            }
        });

        return result;
    };

    self.redraw_order = function () {
        var dfd = $.Deferred(),
            layout = model.get('layout');
        if(layout != 'single_showcase') {
            var blocks_order = model.get('styles.' + layout + '.blocks_order');
            var $item = $('.group-preview .sortable-box', aet_panel);
            var html = self.insert_blocks_into_builder(blocks_order, $item, 1);
            $item.html(html);
        }

        dfd.resolve();
        return dfd;
    };

    // init jQuery UI drag & drop for preview blocks
    self.init_sortable_fields = function(){
        var dfd = $.Deferred();
        var layout = model.get('layout');
        var $item,
            $item_level2,
            $item_level3,
            axis,
            axis_level2,
            axis_level3,
            $clone,
            $wrap,
            helper,
            onstart,
            onupdate;


        if(layout == 'grid'){
            $item = self.preview.find('ul li .sortable-box');
            axis = $item.attr('data-sortable-axis') || 'y';
            helper = function(event, ui) {
                $clone = $(ui).clone();
                $wrap = $('<div></div>');
                $clone.css('display', 'table-cell');
                $wrap.css('display', 'table');
                $wrap.css('vertical-align', 'middle');
                $wrap.append($clone);
                $wrap.css('margin', $(ui).css('margin'));
                $wrap.css('width', '100%');
                return $wrap;
            };
            onstart = function(event, ui){
                ui.placeholder.height(ui.helper.height());
                ui.placeholder.width(ui.helper.width());
                ui.placeholder.css('display', ui.helper.css('display'));
                ui.placeholder.css('margin', ui.helper.css('margin'));
            };
            onupdate = function (event, ui) {
                var blocks = $(this).find('.sortable');
                var order = [];
                $.each(blocks, function () {
                    var block = $(this).attr('data-block-name');
                    order.push(block);
                });
                $('[name="group_blocks_order"]', aet_panel).val(JSON.stringify(order)); // set new blocks order to hidden field
                model.set('styles.' + model.get('layout') + '.blocks_order', order);
            };
            self.bind_sortable($item, axis, helper, onstart, onupdate);
        }
        if(layout == 'grid_float'|| layout == 'widget'){
            $item = self.preview.find('ul li .sortable-box');
            $item_level2 = self.preview.find('ul li .sortable-box.level-2');
            $item_level3 = self.preview.find('ul li .sortable-box.level-3');
            axis = $item.attr('data-sortable-axis') || 'y';
            axis_level2 = 'x';
            axis_level3 = 'y';
            helper = function(event, ui) {
                $clone = $(ui).clone();
                $wrap = $('<div></div>');
                $clone.css('display', 'table-cell');
                $wrap.css('display', 'table');
                $wrap.css('vertical-align', 'middle');
                $wrap.append($clone);
                $wrap.css('margin', $(ui).css('margin'));
                $clone.css('width', '100%');
                $clone.css('text-align', $(ui).css('text-align'));
                return $wrap;
            };
            onstart = function(event, ui){
                ui.placeholder.height(ui.helper.height());
                ui.placeholder.width(ui.helper.width());
                ui.placeholder.css('display', ui.helper.css('display'));
                ui.placeholder.css('margin', ui.helper.css('margin'));
            };
            var onstart_level2 = function(event, ui){
                ui.placeholder.height(ui.helper.height());
                ui.placeholder.width(ui.helper.width());
                ui.placeholder.css('display', 'table-cell');
            };
            onupdate = function (event, ui) {
                var blocks = self.preview.find('ul li .sortable-box.level-1 .sortable');
                var order = {};
                var i = 0;

                _.each(blocks, function (item, index, list) {
                    var block = $(item).attr('data-block-name');
                    var $parent = $(item).parent();

                    if($parent.hasClass('level-1')){
                        order['block_' + i] = block;
                    }
                    else if($parent.hasClass('level-2')){
                        if(order.level2 === undefined){
                            order.level2 = {};
                        }
                        order.level2['block_' + i] = block;
                    }
                    else if($parent.hasClass('level-3')){
                        if(order.level2 === undefined){
                            order.level2 = {};
                        }
                        if(order.level2.level3 === undefined){
                            order.level2.level3 = {};
                        }
                        order.level2.level3['block_' + i] = block;
                    }
                    i++;
                });
                $('[name="group_blocks_order"]', aet_panel).val(JSON.stringify(order)); // set new blocks order to hidden field
                model.set('styles.' + model.get('layout') + '.blocks_order', order);
            };
            self.bind_sortable($item, axis, helper, onstart, onupdate);
            self.bind_sortable($item_level2, axis_level2, helper, onstart_level2, onupdate);
            self.bind_sortable($item_level3, axis_level3, helper, onstart, onupdate);
        }
        if(layout == 'single'){
            $item = self.preview.find('ul li .sortable-box');
            axis = $item.attr('data-sortable-axis') || 'y';
            helper = function(event, ui) {
                $clone = $(ui).clone();
                $wrap = $('<div></div>');
                $clone.css('display', 'block');
                $clone.css('margin-top', 0);
                $wrap.css('display', 'block');
                $wrap.css('vertical-align', 'middle');
                $wrap.append($clone);
                $wrap.css('margin-top', $(ui).css('margin-top'));
                $wrap.css('width', '100%');
                $wrap.css('left', 'calc(50% - ' + $(ui).width() / 2 + 'px)');
                return $wrap;
            };
            onstart = function(event, ui){
                ui.placeholder.height(ui.helper.height());
                ui.placeholder.width(ui.helper.width());
                ui.placeholder.css('margin', '0 auto');
                ui.placeholder.css('display', ui.helper.css('display'));
                ui.placeholder.css('margin-top', ui.helper.css('margin-top'));
            };
            onupdate = function (event, ui) {
                var blocks = $(this).find('.sortable');
                var order = [];
                $.each(blocks, function () {
                    var block = $(this).attr('data-block-name');
                    order.push(block);
                });
                $('[name="group_blocks_order"]', aet_panel).val(JSON.stringify(order)); // set new blocks order to hidden field
                model.set('styles.' + model.get('layout') + '.blocks_order', order);
            };
            self.bind_sortable($item, axis, helper, onstart, onupdate);
        }
        if(layout == 'single_showcase'){
            $item = self.preview.find('.sortable-box.level-1');
            $item_level2 = self.preview.find('.sortable-box.level-2');
            axis = $item.attr('data-sortable-axis') || 'y';
            helper = function(event, ui) {
                $clone = $(ui).clone();
                $wrap = $('<div></div>');
                $clone.css('display', 'block');
                $clone.css('margin-top', 0);
                $wrap.css('display', 'block');
                $wrap.css('vertical-align', 'middle');
                $wrap.append($clone);
                $wrap.css('margin-top', $(ui).css('margin-top'));
                $wrap.css('padding', $(ui).css('padding'));
                $wrap.css('width', '100%');
                $wrap.css('left', 'calc(50% - ' + $(ui).width() / 2 + 'px)');
                return $wrap;
            };
            onstart = function(event, ui){
                ui.placeholder.height(ui.helper.height());
                ui.placeholder.width(ui.helper.width());
                ui.placeholder.css('margin', '0 auto');
                ui.placeholder.css('padding', ui.helper.css('padding'));
                ui.placeholder.css('display', ui.helper.css('display'));
                ui.placeholder.css('margin-top', ui.helper.css('margin-top'));
            };
            onupdate = function (event, ui) {
                var blocks = self.preview.find('.sortable-box.level-1 .testimonials-box');
                var order = {};
                var i = 0;
                _.each(blocks, function (item, index, list) {
                    var block = $(item).attr('data-block-name');
                    var $parent = $(item).parent();

                    if($parent.hasClass('level-1')){
                        order['block_' + i] = block;
                    }
                    else if($parent.hasClass('level-2')){
                        if(order.level2 === undefined){
                            order.level2 = {};
                        }
                        order.level2['block_' + i] = block;
                    }
                    i++;
                });
                $('[name="group_blocks_order"]', aet_panel).val(JSON.stringify(order)); // set new blocks order to hidden field
                model.set('styles.' + model.get('layout') + '.blocks_order', order);
            };
            self.bind_sortable($item, axis, helper, onstart, onupdate);
            self.bind_sortable($item_level2, axis, helper, onstart, onupdate);
        }

        dfd.resolve();
        return dfd;
    };

    self.set_rgba_color = function (field, color) {
        var model_base = 'styles.' + model.get('layout') + '.';
        var rgba = color.toRGB();
        color = 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a + ')';
        model.set(model_base + field, color);
    };

    // init colorpickers
    self.init_colorpicker = function () {
        var dfd = $.Deferred();

        // main form colorpickers
        $.each(self.colorpickers, function (index, key) {
            var $el = $('.' + key + '_color', aet_panel);
            var colorpicker = 'colorpicker_' + key + '_color';

            if(!$el.data('colorpicker')){
                window[colorpicker] = $el.colorpicker({
                    container: $('.' + key + '_color .color', aet_panel),
                }).on('changeColor.colorpicker', function (e) {
                    self.set_rgba_color(key + '_color', e.color);
                });
            }else{
                window[colorpicker] = $el.colorpicker('setValue', model.get('styles.' + model.get('layout') + '.' + key + '_color'));
            }
        });

        return dfd;
    };

    // two way data binding for preview tooltips
    self.bind_tooltips = function () {
        $('.group-photo-settings select', aet_panel).on('change', function () {
            var field = $(this).attr('data-field');
            var val = $(this).val();
            model.set('styles.' + model.get('layout') + '.' + field, val);
        });

        // bind some shit on photo size change
        $('.group-photo-settings [name="group_photo_size_select"]', aet_panel).on('change', function () {
            var val = $(this).val();
            var layout = model.get('layout');
            var photo = $('.testimonial_photo img', aet_panel);

            if(layout != 'grid' || layout != 'grid_float'){
                return false;
            }

            $('[name="group_photo_size"]', aet_panel).val(val);
        });

        // handle btn group changes for radiobuttons-like inputs
        $('.btn-group-radio .btn', aet_panel).on('click', function(e){
            e.preventDefault();
            var $el = $(this);
            var node = $el.attr('data-model-node') || '';
            var $parent = $el.parent('.btn-group');
            var $input = $el.find('input');
            var value = $input.attr('data-value');
            var field_name = $parent.attr('data-field-name');
            if(node == 'root'){
                field_name = field_name;
            }
            if(node == 'form'){
                field_name = node + '.' + field_name
            }
            if(node == ''){
                field_name = 'styles.' + model.get('layout') + '.' + field_name;
            }
            var option_name = $el.attr('data-option-name');

            $input.prop('checked', 'checked');
            $input.val(value);

            $parent.find('.btn').removeClass('active');
            model.set(field_name + '_' + option_name, value);
            $el.addClass('active');
        });

        // handle btn group changes for checkbox-like inputs
        $('.btn-group-checkbox .btn', aet_panel).on('click', function(e){
            e.preventDefault();
            var $el = $(this);
            var $input = $el.find('input');
            var field_name = $input.attr('name').split('group_').join('');
            field_name = 'styles.' + model.get('layout') + '.' + field_name;

            if(parseInt($input.val()) == 1){
                model.set(field_name, '0');
                $input.val('0');
                $el.removeClass('active');
            }else{
                model.set(field_name, '1');
                $input.val('1');
                $el.addClass('active');
            }
        });

        // show tooltip on A glyphicon click
        $('[data-action="call-tooltip"]', aet_panel).on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var field = $(this).parent().attr('data-tooltip-name');
            var $toolptip = $('[data-field="' + field + '"]', aet_panel);

            $('.a-tooltip-wrapper', aet_panel).css('visibility', 'hidden').css('opacity', 0);
            $toolptip.css('visibility', 'visible').css('opacity', 1);
        });

        // hide tooltip on document click anywhere outside tooltip
        $(document).on('click', function (e) {
            if(typeof aet_panel === 'undefined'){
                return;
            }
            if( !$(e.target).parents('.a-tooltip-wrapper').length &&
                !$(e.target).is('[data-action="call-tooltip"]') &&
                !$(e.target).parents('button').is('[data-action="call-tooltip"]')
                ){
                    var $tooltip = $('.live-preview .a-tooltip-wrapper', aet_panel);
                    if($tooltip.is(':visible')){
                        $tooltip.css('visibility', 'hidden').css('opacity', 0);
                    }
                }
        });

        // Init Backbone views for tooltips
        $.each(self.tooltips, function (key, value) {
            var type = value.type.replace_all('_', '').capitalize();
            var view_name = 'GroupTooltip' + type;

            var tooltip = 'view_tooltip_' + key;
            window[tooltip] = new window[view_name]({
                model: window.model,
                el: $('.' + key + '_settings', aet_panel),
                field_name: key // set current field name for data bindings
            });
            window[tooltip].render();
        });
    };

    // init tooltips for each preview block (tooltips list stored in self.tooltips)
    self.init_tooltips = function () {
        var dfd = $.Deferred();
        $.each(self.tooltips, function (key, value) {
            var args = {
                key: key,
                width: value.width,
                viewport: '.a-slide-panel',
                direction: 'bottom',
                container: $('#group-tooltips', aet_panel),
                content: '#group-' + value.type + '-settings',
                data: {
                    field_name: key,
                    hint: value.hint
                }
            };
            window[key + '_tooltip'] = new AwesomeTooltip(args);
            window[key + '_tooltip'].init();
        });
        self.bind_tooltips();
        dfd.resolve();
        return dfd;
    };
    
    self.init_help = function () {
        var dfd = $.Deferred();
        var $clone = $('#preview-help').clone().removeAttr('id').attr('panel', 'preview-help').css({'zIndex': 4});
        $('#group-form .col-md-4').append($clone.addClass('at-transition'));
        dfd.resolve();
        return dfd;
    };

    self.destroy_colorpickers = function () {
        $.each(self.colorpickers, function (index, key) {
            var colorpicker = 'colorpicker_' + key + '_color';
            delete window[colorpicker];
        });
    };

    // destroy preview
    self.destroy = function(){
        $(document).off('click', '[data-action="icon-manager"]');
        $(document).off('click', '[data-action="change-rating-icon"]');
        $(document).off('click', '[data-action="replace1-rating-icon"]');
        $('.toggle').off();
        $('select', aet_panel).dropdown('destroy');
        $('#group-tooltips', aet_panel).html('');
        preview_view.close();
        group_form_view.close();
        $.each(self.tooltips, function (key, value) {
            window['view_tooltip_' + key ].close();
        });
        $.each(self.tooltips, function (key, value) {
            window[key + '_tooltip'].destroy();
        });
        self.destroy_colorpickers();
        $(document).off('click', '[data-action="upload_photo"]');
    };

    self.reinit = function () {
        var form = new AwesomeForm();
        form.init(model.attributes.styles); // refill form
        self.show_fields();
        self.bind_preview();
        var def6 = self.init_tooltips();
        self.init_sortable_fields();
    };
    
    // init preview
    self.init = function(){
        var form = new AwesomeForm();

        var def1 = form.init(model); // refill form
        var def3 = self.show_fields();
        var def4 = self.bind_form();
        var def5 = self.bind_preview();
        var def6 = self.init_tooltips();
        var def7 = self.init_sortable_fields();

        var dfd = $.Deferred();
        $.when(def1, def3, def4, def5, def6, def7).then(function () {
            self.init_colorpicker();
            $('select', aet_panel).dropdown();
            dfd.resolve();
        });
        return dfd;
    };
};